/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteReplyExtraInfo,
    JsonInviteReplyExtraInfoFromJSON,
    JsonInviteReplyExtraInfoFromJSONTyped,
    JsonInviteReplyExtraInfoToJSON,
} from './JsonInviteReplyExtraInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInviteReplyExtraInfo
 */
export interface ApiResultOfJsonInviteReplyExtraInfo {
    /**
     * 
     * @type {JsonInviteReplyExtraInfo}
     * @memberof ApiResultOfJsonInviteReplyExtraInfo
     */
    data?: JsonInviteReplyExtraInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtraInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInviteReplyExtraInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtraInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyExtraInfo
     */
    result?: ApiResultOfJsonInviteReplyExtraInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteReplyExtraInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteReplyExtraInfoFromJSON(json: any): ApiResultOfJsonInviteReplyExtraInfo {
    return ApiResultOfJsonInviteReplyExtraInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteReplyExtraInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInviteReplyExtraInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteReplyExtraInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteReplyExtraInfoToJSON(value?: ApiResultOfJsonInviteReplyExtraInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteReplyExtraInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

